{
  "Clear search": "清除搜索"
}
